module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/005_Preface#fm-1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Abbreviations#fm-2"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction#fm-3"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction#sec-1"
    }
  }, [_vm._v("No “Theology of Paul”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction#sec-2"
    }
  }, [_vm._v("The Benefits of Deconstruction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#ch-1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Romans 3:21–26 and the Faith of Jesus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-3"
    }
  }, [_vm._v("Faith as the Confession of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-4"
    }
  }, [_vm._v("Faith as Response to God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-5"
    }
  }, [_vm._v("Faith as Obedience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-6"
    }
  }, [_vm._v("The Obedience of Jesus as the Faith of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-7"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#ch-2"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Social Dimensions of Sōtēria in Luke-Acts and Paul")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-8"
    }
  }, [_vm._v("The Question")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-9"
    }
  }, [_vm._v("Comparative Method")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-10"
    }
  }, [_vm._v("Criteria for Comparison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-11"
    }
  }, [_vm._v("The Social Character of Salvation in Luke-Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec2-1"
    }
  }, [_vm._v("The Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec2-2"
    }
  }, [_vm._v("Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-12"
    }
  }, [_vm._v("The Social Dimension of Salvation in Paul’s Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec2-3"
    }
  }, [_vm._v("Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec2-4"
    }
  }, [_vm._v("Corinthian Correspondence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec2-5"
    }
  }, [_vm._v("Thessalonian Correspondence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec2-6"
    }
  }, [_vm._v("Captivity Correspondence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-13"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Transformation of the Mind and Moral Discernment in Romans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A First Look at Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Second Look at Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Glance at Aristotle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Measure of Faith and the Mind of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Role of the Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evidence from Other Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Life-Giving Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Argument in 1 Corinthians 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Functions of the Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Body in Question")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thinking Body")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Assembly as the Sōma Christou")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sexual Involvement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Implications of Meals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Glossolalia and the Embarrassments of Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nature of the Phenomenon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pervasiveness of the Phenomenon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evaluations of Glossolalia by New Testament Writers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ambiguous Character of Glossolalia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossolalia and Deviance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("God Was in Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mythic Character of 2 Corinthians 5:19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Language in 2 Corinthians 5:1–21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Logic of Mythic Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Truth and Reconciliation in 2 Corinthians")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reality of Alienation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emotional Truth of Hurt and Anger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Roots of Reconciliation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Body Language of Reconciliation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ritual Imprinting and the Politics of Perfection")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reconstructing the Ritual")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Many Initiations?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Initiation into the Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mysterious Initiation in Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ritual Initiation and Status Elevation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jewish and Christian Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Character of Paul’s Response")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Truth of Christian Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter10#sec-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rhetorical Situation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter10#sec-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of the Galatians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter10#sec-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter10#sec-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter10#sec-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter10#sec-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Expression of Christian Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter11#sec-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Attractions and Perils of Heteronomy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter11#sec-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Paradoxical Character of Christian Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter11#sec-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deciphering Galatians 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter11#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Assertions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter11#sec2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mutual Care, Individual Responsibility (Gal 6:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter11#sec2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sharing All Good Things")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter11#sec-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Paul’s Vision of the Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter12#sec-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Ecclesial Focus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter12#sec-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israel and the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter12#sec-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mission of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter12#sec-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church in Metaphor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter12#sec-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Organization in the Local Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter12#sec-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church in Colossians and Ephesians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter12#sec-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church in the Pastorals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter12#sec-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Rise of Church Order")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter13#sec-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church as Historical Phenomenon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter13#sec-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eschatology and Church Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter13#sec-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rise and Development of Church Order")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter13#sec-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter13#sec-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter13#sec-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Fellowship of Suffering")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter14#sec-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Present Gift: The Power of God and the Power of the Resurrection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter14#sec-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ambiguities of Weakness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter14#sec-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suffering With and For")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter14#sec-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter14#sec-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mind of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter14#sec-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mind of the Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter14#sec-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living Examples of the Mind of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter14#sec-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Mystery and Metaphor in Colossians")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mystery of Christ among the Gentiles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Usage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mystērion in Colossians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What the Colossians Have Been Given in Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Metaphors of Christian Maturity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stability")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("True and False")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life and Growth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mystery and Metaphor in Baptism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter15#sec-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Doing the Truth in Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter16#sec-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evidence in Paul on Sex and Gender")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter16#sec-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex and Gender Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter16#sec-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Necessary Excursus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter16#sec-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doing the Truth in Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter16#sec-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter17#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sacrament of the World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter17#sec-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church as Place of God’s Reconciliation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter17#sec-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church and Christ, Wife and Husband")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter17#sec-93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Nonrealized Eschatology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter17#sec-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coda: The Circumstances of Composition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Discernment, Edification, and Holiness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#sec-95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building the Ekklēsia in 1 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#sec2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#sec2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edification")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#sec2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discernment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#sec-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Community Construction in Other Pauline Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#sec2-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#sec2-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ephesians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter18#sec-97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Apostle as Crisis Manager")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec-98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crisis in Thessaloniki")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec-99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Response to the Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cognitive Correction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Pressure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Coercion in Other Canonical Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galatians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Letters to Paul’s Delegates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter19#sec-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter20#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Oikonomia Theou")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter20#sec-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clarifications and Caveats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter20#sec-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Composition and Setting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter20#sec-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Theological Perspective of 1 Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter20#sec-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter20#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Response to an Incisive Critique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter20#sec-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Search for a “Theological Voice”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter20#sec-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Translation and Function of 1 Timothy 1:4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter21#ch-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Shape of the Struggle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter21#sec-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preliminary Observations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter21#sec-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Exegetical Challenge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter21#sec-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Connections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter21#sec-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#ch-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Second Timothy and the Polemic against False Teachers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Timothy: A Personal Paraenetic Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Timothy 1:3–2:13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Timothy 2:14–4:8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hellenistic Materials Pertinent to Understanding 2 Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epictetus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lucian of Samosata")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dio Chrysostom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paraenesis and Polemic in 1 Timothy and Titus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Titus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter22#sec-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter23#ch-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Pedagogy of Grace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter23#sec-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rhetorical Situation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter23#sec-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rhetorical Response")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter23#sec-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gift That Teaches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter23#sec-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Experience of God’s Goodness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter23#sec-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Conclusion#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Acknowledgments#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Bibliography#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45de19eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0